import { FC } from 'react';
import ProductPrice from '@base/snippets/ProductPriceV3';
import styles from './index.module.less';
import { useTrans, Trans } from 'base/utils/i18n';
import { TActivityStatus } from 'base/utils/flashsale';
import cn from 'classnames';
import { IProduct } from 'mod/product/interface';

type IProps = {
    product: IProduct;
    activityStock: number;
    status: TActivityStatus;
};

export const PriceAndStock: FC<IProps> = props => {
    const { product, activityStock, status } = props;
    const { t } = useTrans();
    return (
        <div className={cn(styles['prices-stock'], 'g-prices-stock')}>
            <div className={cn(styles.prices)}>
                <ProductPrice
                    product={product}
                    direction={'vertical'}
                />
            </div>

            <div className={cn(styles.stock, 'g-stock')}>
                {status !== 'ended' && (
                    <>
                        {activityStock === 0
                            ? t('web_product_sold_out')
                            : (
                                <Trans
                                    i18nKey="web_home_sfs_stock_left"
                                    components={{ Num: <span className={styles.num}>{activityStock}</span> }}
                                />
                            )
                        }
                    </>
                )}
            </div>

        </div>
    );
};